// Stake
export const GET_STAKES = "GET_STAKES";
export const GET_STAKES_FAIL = "GET_STAKES_FAIL";
export const GET_STAKES_SUCCESS = "GET_STAKES_SUCCESS";

// Stats
export const GET_STAKE_STATS = "GET_STAKE_STATS";
export const GET_STAKE_STATS_FAIL = "GET_STAKE_STATS_FAIL";
export const GET_STAKE_STATS_SUCCESS = "GET_STAKE_STATS_SUCCESS";
